import { Sparkles, ShieldCheck, RefreshCw } from "lucide-react";

const ITEMS = [
  { icon: Sparkles, title: "Curated goods", note: "Every item earns its shelf" },
  { icon: ShieldCheck, title: "Secure checkout", note: "Powered by Shopify" },
  { icon: RefreshCw, title: "New finds weekly", note: "The catalogue keeps growing" },
];

export default function TrustStrip() {
  return (
    <div data-testid="trust-strip" className="border-b border-line bg-bone">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-6 px-6 py-8 sm:grid-cols-3 md:px-12">
        {ITEMS.map(({ icon: Icon, title, note }) => (
          <div key={title} className="flex items-center gap-4">
            <Icon className="h-5 w-5 shrink-0 text-ember" strokeWidth={1.5} />
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-ink">{title}</p>
              <p className="mt-0.5 text-xs text-smoke">{note}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
